<template>
  <main class="dashboard links">
    <div class="mb-4">
      <h2>Проект <span>{{ project?.name }}</span></h2>
      <h3>Персона {{ person?.name }} ID ({{ person?.pf_id }})</h3>
      <BackButton></BackButton>
    </div>
    <div class="filters mb-5">
      <router-link :to="{name: 'pdf_db_all_links', params: {id: this.$route.params.id,}}" type="button"
                   class="btn btn-sm btn-outline-dark me-3">Ссылки
      </router-link>
      <button class="btn-outline-success btn btn-sm" @click="add_new=true">Добавить +</button>
    </div>

    <div class="screen-list">


      <div class="header">

      </div>
      <div v-if="!pdf && add_new" class="mb-4">
        <div class="btn-group" role="group" aria-label="Basic radio toggle button group">
          <template v-for="(name, key) in sources">
            <input type="radio" class="btn-check" name="source" :id="'source'+key" autocomplete="off" :value="key"
                   v-model="source">
            <label class="btn btn-outline-dark" :for="'source'+key">{{ name }}</label>
          </template>

        </div>
        <div
            :class="['dropzone-area', dragging ? 'dropzone-over' : '']"
            drag-over="handleDragOver"
            @dragenter="dragging=true"
            @dragleave="dragging=false">

          <div class="dropzone-text">
            <span class="dropzone-title">Перетащите файл сюда или кликните для выбора</span>
            <span class="dropzone-info">PDF file</span>
          </div>
          <input type="file" accept="application/pdf" @change="onFileChange">
        </div>
      </div>
      <div class="dropzone-preview">
        {{ pdf.name }}
        <button @click="removeFile" class="btn btn-sm btn-outline-dark" v-if="pdf">Загрузить другой</button>
      </div>

      <div class="table-responsive" style="height: auto">
        <div class="table">
          <table>

            <thead>
            <tr>
              <th>Источник</th>
              <th>Файлов из источника</th>
              <th>Ссылок</th>
              <th>В отчёт</th>
              <th>Дата создания</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="file in files">
              <td>
                <router-link
                    :to="{name: 'pdf_db_detail', params: {id: this.$route.params.id, pdf_source: file.source, pdf_date: file.date_create__date}}">
                  {{ sources[file.source] }}
                </router-link>
              </td>
              <td>{{ file.pdf_count }}</td>

              <td>
                <router-link
                    :to="{name: 'pdf_db_links', params: {id: this.$route.params.id, pdf_source: file.source, pdf_date: file.date_create__date}}">
                  {{ file.links_count }}
                </router-link>
              </td>
              <td>
                <div v-if="file.pdf_layout" class="form-check form-switch ms-1 pt-2">
                  <input class="form-check-input" v-model="file.pdf_layout.selected" @change="setSelected(file.pdf_layout)" type="checkbox" role="switch"
                         id="uniq_link">
                  <label class="form-check-label" for="uniq_link"></label>
                </div>

              </td>
              <td>{{ $moment(file.date_create__date).format("DD.MM.YYYY") }}</td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>

    </div>

  </main>
</template>

<script>

import {PdfApi} from "@/api/pdf";
import {ProjectApi} from "@/api/project";

export default {
  name: 'PdfDB',
  data() {
    return {
      pdf: '',
      dragging: false,
      structure: null,
      sources: [],
      source: "",
      person: null,
      project: null,
      add_new: false,
      files: []
    }
  },
  mounted: function () {
    const $this = this;
    this.projectInfo();
    ProjectApi.get_simple(this.$route.params.id).then(response => {
      $this.project = response
    });

  },
  methods: {
    projectInfo() {
      const $this = this;
      PdfApi.project_info(this.$route.params.id).then(response => {
        $this.sources = response.sources;
        $this.source = Object.keys($this.sources)[0];
        $this.person = response.person;
        $this.files = response.pdf_files;
      })
    },
    onFileChange(e) {
      let files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      this.parserPdf(files[0]);
    },
    parserPdf(file) {
      const $this = this;
      this.pdf = file;
      let formData = new FormData()
      formData.set('file', this.pdf)
      formData.set('source', this.source)
      formData.set('person', this.person.id)
      formData.set('project_id', this.$route.params.id)
      PdfApi.load_pdf(formData).then(() => {
        $this.projectInfo();
        $this.removeFile();
        $this.add_new = false;
      });
    },
    setSelected(layout){
       PdfApi.set_selected({id: layout.id, selected: layout.selected})
    },
    removeFile() {
      this.pdf = '';
    }
  }
}

</script>

<style scoped lang="scss">
.dropzone-over {

  border: 1px solid red !important;
}

.dropzone-area {
  width: 80%;
  height: 150px;
  position: relative;
  border: 2px dashed #CBCBCB;

  &:hover {
    border: 2px dashed #2E94C4;

    .dropzone-title {
      color: #1975A0;
    }

  }
}

.dropzone-area input {
  position: absolute;
  cursor: pointer;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
}

.dropzone-text {
  position: absolute;
  top: 50%;
  text-align: center;
  transform: translate(0, -50%);
  width: 100%;

  span {
    display: block;
    line-height: 1.9;
  }
}

.dropzone-title {
  font-size: 13px;
  color: #787878;
  letter-spacing: 0.4px;
}

.dropzone-info {
  font-size: 13px;
  color: #A8A8A8;
  letter-spacing: 0.4px;
}

.dropzone-button {
  position: absolute;
  top: 10px;
  right: 10px;
  display: none;
}

.dropzone-preview {
  width: 80%;
  position: relative;

  &:hover .dropzone-button {
    display: block;
  }

  img {
    display: block;
    height: auto;
    max-width: 100%;
  }

}

</style>
